require('./myHockeyTvController');
require('../collegeCommitments/collegeCommitmentsDirective');

require('./followersFollowing/followersFollowing');
require('./myFeed/myFeed');
require('./myGames/myGames');
require('./upcomingSchedule/upcomingSchedule');
require('./watchClips/watchClips');
require('./manageReminders/manageReminders');

"use strict";

angular.module('app.myHockeyTv', [
    'app.myHockeyTv.myHockeyTvController',
    'app.collegeCommitments.collegeCommitmentsDirective',
    'app.myHockeyTv.followersFollowing',
    'app.myHockeyTv.myFeed',
    'app.myHockeyTv.myGames',
    'app.myHockeyTv.upcomingSchedule',
    'app.myHockeyTv.watchClips',
    'app.myHockeyTv.manageReminders'
])
    .config([
        '$stateProvider',
        'PRODUCT',
        function ($stateProvider, product) {
            $stateProvider
                .state('app.myHockeyTv', {
                    abstract: true,
                    url: '/my_' + product.Name.toLowerCase(),
                    templateUrl: 'components/myHockeyTv/myHockeyTvView.html',
                    controller: 'app.myHockeyTv.myHockeyTvController',
                    title: 'My ' + product.Name
                })
                .state('app.myHockeyTv.collegeCommitments', {
                    url: '/college_commitments',
                    template: '<college-commitments></college-commitments>',
                    subTitle: 'College Commitments',
                    isChildState: true
                });
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/myHockeyTv/myHockeyTv.js